import { Button, Collapse, Drawer, IconButton, Stack, SvgIcon } from '@mui/material'
import { useState } from 'react'
import { NavLink } from 'react-router'
import * as R from 'remeda'
import { routes } from '~/features/routes'
import { buttonStyles } from './styles'
import { supabaseApi } from '~/supabase/api'
import { IconCaretDownFilled, IconMenu3, IconX } from '@tabler/icons-react'
import { AgentButton } from '../agent'
import { canAccessEntry, useRole } from '~/features/auth/useRole'
import { RoleErrorState } from './RoleErrorState'

const list = R.values(routes).filter((v) => v.inSidebar)

export const MobileMenu = () => {
  const [open, setOpen] = useState(false)
  const [expand, setExpand] = useState<string | null>(null)
  const { role, isError, refetch } = useRole()
  // Without a role every entry would be hidden, so show the error state instead
  const visibleRoutes = isError ? [] : list

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <Stack>
      <Stack
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between', flex: 1 }}
      >
        {role !== 'marketing' && <AgentButton />}
        <IconButton onClick={() => setOpen(!open)}>
          <SvgIcon>
            <IconMenu3 />
          </SvgIcon>
        </IconButton>
      </Stack>
      <Drawer open={open} onClose={handleClose}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end', p: 2 }}>
          <SvgIcon>
            <IconX />
          </SvgIcon>
        </IconButton>
        <Stack gap={1} mt={6} width="70vw" flex={1}>
          {isError ? (
            <Stack px={2}>
              <RoleErrorState onRetry={() => refetch()} />
            </Stack>
          ) : null}
          {visibleRoutes.map((entry) => {
            const { route, menu, label, Icon, key } = entry
            const isExpanded = expand === key

            if (menu) {
              const visibleItems = R.values(menu).filter((item) => canAccessEntry(role, item))
              if (visibleItems.length === 0) return null

              return (
                <Stack px={2} key={route}>
                  <Button
                    endIcon={
                      <SvgIcon
                        sx={{
                          transform: `rotate(${isExpanded ? 180 : 0}deg)`,
                          transition: (t) =>
                            t.transitions.create(['transform'], {
                              duration: t.transitions.duration.short,
                            }),
                        }}
                      >
                        <IconCaretDownFilled />
                      </SvgIcon>
                    }
                    onClick={() => setExpand((prev) => (prev ? null : key))}
                    sx={buttonStyles}
                  >
                    {label}
                  </Button>
                  <Collapse in={isExpanded}>
                    <Stack ml={2}>
                      {visibleItems.map(({ route: MenuItemRoute, label, Icon: MenuItemIcon }) => {
                        return (
                          <Button
                            key={MenuItemRoute}
                            endIcon={MenuItemIcon}
                            component={NavLink}
                            to={MenuItemRoute}
                            sx={buttonStyles}
                          >
                            {label}
                          </Button>
                        )
                      })}
                    </Stack>
                  </Collapse>
                </Stack>
              )
            }

            if (!canAccessEntry(role, entry)) return null

            return (
              <Stack px={2} key={route}>
                <Button component={NavLink} to={route} endIcon={Icon} sx={buttonStyles}>
                  {label}
                </Button>
              </Stack>
            )
          })}
          <Button
            onClick={() => supabaseApi.auth.signOut()}
            sx={{ mt: 'auto', mb: 4, mx: 2 }}
            variant="contained"
          >
            Log out
          </Button>
        </Stack>
      </Drawer>
    </Stack>
  )
}
